import { styled } from "@mui/material/styles";
import { Box, MenuItem, TextField, Typography } from "@mui/material";
import { useState, useRef, useEffect } from "react";

export const Flex = styled(Box)(({ theme }) => ({
    display: 'flex',
}));

export const RowFlex = styled(Flex)(({ theme }) => ({
    flexDirection: 'row',
}));

export const RowJustifyStartFlex = styled(Flex)(({ theme }) => ({
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minWidth: 0,
}));

export const RowJustifyEndFlex = styled(Flex)(({ theme }) => ({
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
}));

export const RowJustifyCenterFlex = styled(Flex)(({ theme }) => ({
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
}));

export const RowJustifySpaceBetweenFlex = styled(Flex)(({ theme }) => ({
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
}));

export const ColumnFlex = styled(Flex)(({ theme }) => ({
    flexDirection: 'column',
}));

export const ColumnJustifyStartFlex = styled(Flex)(({ theme }) => ({
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
}));

export const ColumnJustifyEndFlex = styled(Flex)(({ theme }) => ({
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center',
}));

export const ColumnJustifyCenterFlex = styled(Flex)(({ theme }) => ({
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
}));

export const FlexFill = styled(Flex)(({ theme }) => ({
    width: '100%',
    height: '100%',
    minHeight: 0,
}));

export const RowDirectionFlexFill = styled(FlexFill)(({ theme }) => ({
    flexDirection: 'row',
}));

export const ColumnDirectionFlexFill = styled(FlexFill)(({ theme }) => ({
    flexDirection: 'column',
}));

export const ColumnDirectionAlignStartFlexFill = styled(ColumnDirectionFlexFill)(({ theme }) => ({
    justifyContent: 'flex-start',
}));

export const ColumnDirectionJustifyCenterAlignCenterFlexFill = styled(FlexFill)(({ theme }) => ({
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
}));

export const WidthOccupy = styled(Flex)(({ theme }) => ({
    flex: '1 1 auto',
    flexDirection: 'row',
}));

export const HeightOccupy = styled(Flex)(({ theme }) => ({
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
}));

export const VerticalScroll = styled(Flex)(({ theme }) => ({
    flex: '0 1 auto',
    minHeight: 0,
    overflow: 'auto',
    flexDirection: 'column',
}))

export const RoundedBlackBoundary = styled(RowJustifyStartFlex)(({ theme }) => ({
    outline: '2px solid black',
    borderRadius: theme.spacing(2),
    padding: '0px 4px 0px 4px',
    gap: theme.spacing(1),
}));

export const StyledTextField = ({ size, variant = "standard", width = '25ch', value, valueHandler, multiline = false, maxRows, editing }) => {
    const timeoutRef = useRef(null);
    const [internalValue, setInternalValue] = useState(value ?? '');

    useEffect(() => {
        setInternalValue(value ?? '');
    }, [value]);

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const delayedValueHandler = (val) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => valueHandler(val), 500);
    };

    const onChange = (e) => {
        const val = e.target.value;
        setInternalValue(val);
        delayedValueHandler(val);
    };

    return !editing ? <Typography variant="body2">{value}</Typography> : <TextField size={size} variant={variant} multiline={multiline} sx={{ width: width, }} value={internalValue} onChange={onChange} maxRows={maxRows} />;
};

export const BorderedTextField = ({ width = '25ch', value, valueHandler, multiline = false, maxRows, editing }) => {
    return <StyledTextField editing={editing} size="small" variant="outlined" width={width} value={value} valueHandler={valueHandler} multiline={multiline} maxRows={maxRows} />
};

export const StyledSelectField = ({ width = '15ch', value, valueHandler, options, editing }) => {
    return !editing ? <Typography variant="body2">{options.find(e => e.value === (value || ''))?.name}</Typography> : <TextField select variant="standard" sx={{ width: width, }} value={value} onChange={(e) => valueHandler(e.target.value)}>
        {options && options.map(e => <MenuItem key={e.value} value={e.value}>
            {e.name}
        </MenuItem>)}
    </TextField>
};

export const BorderedOutlineRowDirectionFlex = styled(Flex)(({ theme }) => ({
    flexDirection: 'row',
    outline: '1px solid black',
    borderRadius: theme.spacing(2),
}));

export const BorderedOutlineColumnDirectionFlex = styled(Flex)(({ theme }) => ({
    flexDirection: 'column',
    outline: '1px solid black',
    borderRadius: theme.spacing(2),
}));
